import api from './api';

class CashService {
  async getCurrentSession() {
    const response = await api.get('/cash/current');
    return response.data;
  }

  async getRegisters() {
    const response = await api.get('/cash/registers');
    return response.data;
  }

  async createRegister(data) {
    const response = await api.post('/cash/registers', data);
    return response.data;
  }

  async updateRegister(id, data) {
    const response = await api.put(`/cash/registers/${id}`, data);
    return response.data;
  }

  async openSession(data) {
    const response = await api.post('/cash/open', data);
    return response.data;
  }

  async closeSession(data) {
    const response = await api.post('/cash/close', data);
    return response.data;
  }

  async createMovement(data) {
    const response = await api.post('/cash/movements', data);
    return response.data;
  }

  async getSessions(params = {}) {
    const response = await api.get('/cash/sessions', { params });
    return response.data;
  }

  async getDailyReport(date, params = {}) {
    const response = await api.get('/cash/reports/daily', { params: { date, ...params } });
    return response.data;
  }

  async getMonthlyReport(month, params = {}) {
    const response = await api.get('/cash/reports/monthly', { params: { month, ...params } });
    return response.data;
  }

  async exportDailyReport(date, format = 'xlsx', params = {}) {
    const response = await api.get('/cash/reports/daily/export', {
      params: { date, format, ...params },
      responseType: 'blob',
    });
    return response.data;
  }

  async exportMonthlyReport(month, format = 'xlsx', params = {}) {
    const response = await api.get('/cash/reports/monthly/export', {
      params: { month, format, ...params },
      responseType: 'blob',
    });
    return response.data;
  }
}

export default new CashService();
